import ClientOnlyPortal from '@chegg-wt/core/components/ClientOnlyPortal'
import { SUPER_AUTH_IFRAME_MODAL } from '@chegg-wt/core/state/modals/constants'
import { AuthSuccessGrant } from '@chegg/wtf-components'
import React from 'react'
import { Config } from '@chegg-wt/core/config'
import { connect, useSelector } from 'react-redux'
import { Dispatch } from 'redux'
import { LoadingDots } from '@chegg-wt/core/components/LoadingDots'
import { authIframePath } from '@chegg-wt/core/constants/user'
import useSaIframeEventsHandler from '@chegg-wt/core/hooks/useSaIframeEventsHandler'
import { NextJsRoute } from '@chegg-wt/core/types/core'
import { resetSyntheticLocationChange } from '@chegg-wt/core/state/instrumentation/actions'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import { login } from '@chegg-wt/core/state/user/actions'
import { modalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import { SuperAuthIFrameModalData } from './types'
import * as Styled from './styled'

export const iframeTestId = 'test-authiframe'

interface SuperAuthIFrameModalProps {
  closeModal: (origin?: string) => void
  login: (authSuccessGrant: AuthSuccessGrant, redirectTo?: NextJsRoute) => void
}

const SuperAuthIFrameModal: React.FC<SuperAuthIFrameModalProps> = ({
  closeModal,
  login,
}) => {
  const { ref, isSAReady } = useSaIframeEventsHandler({ login, closeModal })
  const data = useSelector(modalDataSelector) as SuperAuthIFrameModalData
  const queryParams = `?display=${data.display}&defaultflow=${data.defaultFlow}&origin=${data.origin}`
  const { basePath } = Config

  return (
    <ClientOnlyPortal>
      {!isSAReady ? (
        <Styled.LoaderOverlay>
          <Styled.LoaderContainer>
            <LoadingDots message="Loading authentication form" />
          </Styled.LoaderContainer>
        </Styled.LoaderOverlay>
      ) : null}
      <Styled.SuperAuthIFrame
        ref={ref}
        data-test={iframeTestId}
        title="Auth Frame"
        src={`${basePath}${authIframePath}${queryParams}`}
        isReady={isSAReady}
      />
    </ClientOnlyPortal>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeModal: (origin?: string) => {
    dispatch(closeModal(SUPER_AUTH_IFRAME_MODAL, origin))
    dispatch(resetSyntheticLocationChange())
  },
  login: (authSuccessGrant: AuthSuccessGrant, redirectTo?: NextJsRoute) =>
    dispatch(login(authSuccessGrant, redirectTo)),
})

export default connect(null, mapDispatchToProps)(SuperAuthIFrameModal)
